import { render, staticRenderFns } from "./Wp_jd_activity.vue?vue&type=template&id=3fc4ed25&"
import script from "./Wp_jd_activity.vue?vue&type=script&lang=js&"
export * from "./Wp_jd_activity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports